 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~vsf-category~vsf-checkout~vsf-cms~vsf-compare~vsf-home~vsf-my-account~vsf-product~vsf-top-ba~dee0c57b","3":"vsf-category~vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-related~vsf-rela~610fdd32","4":"vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-product~vsf-search-panel~vsf-~b3ee85fa","5":"vendors~vsf-category~vsf-wp-categories-show~vsf-wp-posts-index~vsf-wp-posts-show","6":"vsf-color-selector-product~vsf-color-wariant-modal~vsf-product-custom-color","7":"vsf-checkout~vsf-microcart","8":"vsf-microcart~vsf-product","9":"SwipeActions","11":"for-download","12":"lang-pl-PL-json","14":"vendors~bodybuilder","15":"vendors~vsf-category","16":"vendors~vsf-checkout","17":"vendors~vsf-graphql","18":"vendors~vsf-search-panel","19":"vsf-account-icon","20":"vsf-async-bottom-sidebar","21":"vsf-async-sidebar","22":"vsf-blog-preview-product","23":"vsf-category","24":"vsf-checkout","25":"vsf-cms","26":"vsf-color-selector-product","27":"vsf-color-wariant-modal","28":"vsf-compare","29":"vsf-compare-icon","30":"vsf-contact-modal","31":"vsf-desktop-memu","32":"vsf-error","33":"vsf-footer","34":"vsf-forgotpass","35":"vsf-hamburger-icon","36":"vsf-header","37":"vsf-home","38":"vsf-inner-header","39":"vsf-languages-modal","40":"vsf-layout-default","41":"vsf-login","42":"vsf-mic-icon","43":"vsf-microcart","44":"vsf-microcart-icon","45":"vsf-my-account","46":"vsf-not-found","47":"vsf-order-confirmation","48":"vsf-placepozniej","49":"vsf-product","50":"vsf-product-custom-color","51":"vsf-product-gallery-carousel","52":"vsf-product-gallery-overlay","53":"vsf-product-gallery-zoom-carousel","54":"vsf-product-info-modal","55":"vsf-product-tabs","56":"vsf-register","57":"vsf-related","58":"vsf-related-bestseller","59":"vsf-related-small","60":"vsf-reset-password","61":"vsf-search-adapter-0","62":"vsf-search-adapter-1","63":"vsf-search-panel","64":"vsf-search-panel-desktop","65":"vsf-sidebar-menu","66":"vsf-sign-up","67":"vsf-top-bar","68":"vsf-typ","69":"vsf-wishlist","70":"vsf-wishlist-icon","71":"vsf-wp-categories-index","72":"vsf-wp-categories-show","73":"vsf-wp-posts-index","74":"vsf-wp-posts-show"}[chunkId]||chunkId) + "." + {"0":"0d9892dff7ea364c77e1","2":"8902e69046d7f64e1fd2","3":"e536cdf8216afd98d7bc","4":"b827192da3f2db7cea0a","5":"cbe3297f519f785e286a","6":"9062c4902d37d615e8d2","7":"5457c4efce1d72299861","8":"13d3b848b8235122ecc5","9":"76130b1fa25616075b70","11":"35a746a93c06d0c21fa3","12":"b6ad50f87c9e19a62727","14":"501d467d2ad54bb19bc5","15":"0947cbcd1154a4c31788","16":"92c439cd6cf86022aec7","17":"ff28c1153e9cd653ea5e","18":"1146412ad8e3f6d54432","19":"35a83c947a269067ab88","20":"c360130364bec3fef696","21":"825bf51f1ce7b26d93ec","22":"e25af563b7a3f77fb641","23":"e1e31acc0162ccf08440","24":"cd11cb3d5fa7579abec9","25":"ed41fcee839088c8af49","26":"3713d0eff3081cc020fd","27":"1476e23bff51d40c10c2","28":"84aa145c02db72d9f5d7","29":"cad2f9f8f902dbafa6be","30":"105293a42c0b651136fb","31":"3d519d8b6d5d1350e412","32":"46f38e9de707a4b915ad","33":"79cc0f1813d76ca44745","34":"51fa60a011da26d1b70f","35":"837449be44970f3b43ef","36":"3c649d3b800536a2f30f","37":"f245f02fac1e3f7cba5f","38":"c20763df0da742f99591","39":"76cc0629a43219409f2d","40":"4fac984b507519bd0152","41":"ab1d5f11d5a1a61bbc32","42":"f2705b6b15c9b46d4b77","43":"1c895ad92852b120ef16","44":"1feb61d863e15a80764a","45":"5e492448bbe9907cd729","46":"541ae257380734c7c6c9","47":"742901271e2bebc8d25c","48":"3a8f7737d668c49b4b0b","49":"d60729ab8568ba3acdb2","50":"fead79f4fb580c56bc0a","51":"e8ac7df29cf8b1510c1f","52":"17aff5f4e9a6f1bc417f","53":"038733f25e24b327f2ce","54":"78aee7b28e97b700fc96","55":"b28df6dd32dfdc5b975f","56":"c4930e34274f7816fc47","57":"207662b93431c5cbe1ef","58":"291757c05bf1f751804c","59":"3f72e7eb8d18063ac04f","60":"7258e16d6d1a15f02096","61":"bc2c2925df401c1c4118","62":"79a4dfde1fa241c2b393","63":"f19a1cdc451e84b85ec3","64":"988be6d2cd5532c83709","65":"d0f74512a398a8a640a7","66":"916ea057b1348eb603e1","67":"cfec95aa0809ebe030d4","68":"bbd57e796c924b58a187","69":"35648c690d82852edfa0","70":"56cf8965116456e1b669","71":"056c2f62e8732b36baea","72":"988c36ed9b949b5a86a6","73":"e59c69ba893db4ab02e6","74":"cc6f13061b4949a74a9a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"40": [
 				1,
 				7,
 				8,
 				43,
 				3,
 				4,
 				69,
 				65
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
